/* eslint-disable import/no-extraneous-dependencies */
import { rest } from 'msw';
import { USERS_CREDS } from '@/mocks/data';
import { mockServerApi, randomId } from '@/common/utils';
import { AuthChallenges, AuthPassword, AuthRequest, AuthDuoChallenge } from '@/views/auth/interfaces';

export const authRequests = (msw: typeof rest) => [
  msw.post(mockServerApi('/auth/sign-in'), (req: { body: AuthRequest }, res, ctx) => {
    const isNewUser = req.body.email === USERS_CREDS[5].email;
    const duosso = req.body.email === USERS_CREDS[8].email;
    const userCredentials = { email: req.body.email, password: req.body.password };

    if (isNewUser) {
      if (!req.body.challenge) {
        return res(
          ctx.status(200),
          ctx.json({ session: randomId(), challenge: AuthChallenges.NEW_PASSWORD_REQUIRED }),
        );
      }

      // Update newUser password
      USERS_CREDS[5].password = req.body.password;
    }

    if (duosso) {
      return res(
        ctx.status(200),
        ctx.json({ session: randomId(), challenge: AuthChallenges.CUSTOM_CHALLENGE, parameters: { redirect: `${window.location}?duo_code=123` } }),
      );
    }

    if (USERS_CREDS.findIndex((n) => JSON.stringify(n) === JSON.stringify(userCredentials)) === -1) {
      return res(
        ctx.status(401),
        ctx.json({ message: 'Invalid Login Credentials' }),
      );
    }

    window.localStorage.setItem('email', req.body?.email);

    return res(
      ctx.status(200),
      ctx.json({ token: '123', expiresIn: 86400, refreshToken: '345' }),
    );
  }),

  msw.post(mockServerApi('/auth/duo'), (req: { body: AuthDuoChallenge }, res, ctx) => {
    if (!req.body.code) {
      return res(
        ctx.status(500),
      );
    }

    window.localStorage.setItem('email', req.body?.email);

    return res(
      ctx.status(200),
      ctx.json({ token: '123', expiresIn: 86400, refreshToken: '345' }),
    );
  }),

  msw.post(mockServerApi('/auth/sso_state'), (req: { body: AuthRequest }, res, ctx) => {
    const duosso = req.body.email === USERS_CREDS[8].email;

    if (duosso) {
      return res(
        ctx.status(200),
        ctx.json({ state: 'DUO' }),
      );
    }

    return res(
      ctx.status(200),
      ctx.json({ state: 'none' }),
    );
  }),

  msw.post(mockServerApi('/auth/password/forgotten'), (req: { body: { email: string } }, res, ctx) => {
    if (!req.body.email.includes('@craftsmanplus.com')) {
      return res(
        ctx.status(404),
        ctx.json({
          message: 'Email address not valid',
          field: 'email',
        }),
      );
    }

    return res(
      ctx.status(200),
      ctx.json({ message: 'We have sent you a unique reset verification code, please check your email' }),
    );
  }),

  msw.post(mockServerApi('/auth/password/reset'), (req: { body: AuthPassword }, res, ctx) => {
    const validDummyToken = '123456';

    if (req.body.confirmationCode === validDummyToken) {
      return res(
        ctx.status(500),
        ctx.json({
          message: 'Incorrect verification code. Please check your email address',
          error: 'ExpiredCodeException',
          trace: [
            'ExpiredCodeException: Incorrect verification code. Please check your email address',
            '    at Request.extractError (/var/runtime/node_modules/aws-sdk/lib/protocol/json.js:52:27)',
            '    at Request.callListeners (/var/runtime/node_modules/aws-sdk/lib/sequential_executor.js:106:20)',
            '    at Request.emit (/var/runtime/node_modules/aws-sdk/lib/sequential_executor.js:78:10)',
            '    at Request.emit (/var/runtime/node_modules/aws-sdk/lib/request.js:686:14)',
            '    at Request.transition (/var/runtime/node_modules/aws-sdk/lib/request.js:22:10)',
            '    at AcceptorStateMachine.runTo (/var/runtime/node_modules/aws-sdk/lib/state_machine.js:14:12)',
            '    at /var/runtime/node_modules/aws-sdk/lib/state_machine.js:26:10',
            '    at Request.<anonymous> (/var/runtime/node_modules/aws-sdk/lib/request.js:38:9)',
            '    at Request.<anonymous> (/var/runtime/node_modules/aws-sdk/lib/request.js:688:12)',
            '    at Request.callListeners (/var/runtime/node_modules/aws-sdk/lib/sequential_executor.js:116:18)',
          ],
        }),
      );
    }

    return res(
      ctx.status(204),
    );
  }),

  msw.post(mockServerApi('/track'), (req, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      status: 'ok',
      data: JSON.stringify({}),
    }),
  )),

  msw.post(mockServerApi('/auth/refresh'), (req, res, ctx) => res(
    ctx.status(200),
    ctx.json({
      expiresIn: 86400,
      token: '567',
    }),
  )),
];

export default authRequests;
